import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress ResizeObserver errors - catches the error before webpack-dev-server overlay can display it
if (typeof window !== 'undefined') {
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  }, true);
}

// Configure HMR behavior to reduce warnings
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_HMR_FIX) {
  // Override console.warn to filter out HMR dispose warnings
  const originalWarn = console.warn;
  console.warn = (...args) => {
    const message = args.join(' ');
    // Filter out common HMR dispose warnings
    if (message.includes('unexpected require') &&
      (message.includes('react-hook-form') ||
        message.includes('react-dropzone') ||
        message.includes('lucide-react'))) {
      return; // Suppress these specific warnings
    }
    originalWarn.apply(console, args);
  };

  // Suppress WebSocket connection errors (harmless dev server HMR connection issues)
  const originalError = console.error;
  console.error = (...args) => {
    const message = args.join(' ');
    // Filter out WebSocket connection interruption errors
    if (message && (
      message.includes('WebSocket') ||
      message.includes('ws://localhost') ||
      message.includes('connection was interrupted') ||
      message.includes('WebSocketClient'))) {
      return; // Suppress WebSocket connection errors
    }
    originalError.apply(console, args);
  };

  // Suppress WebSocket errors from error events (browser-level errors)
  // Also suppress benign ResizeObserver loop errors
  const originalErrorHandler = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (message && typeof message === 'string') {
      // Suppress ResizeObserver benign errors
      if (message.includes('ResizeObserver loop')) {
        return true;
      }
      // Suppress WebSocket errors
      if (message.includes('WebSocket') ||
        message.includes('ws://localhost') ||
        message.includes('connection was interrupted') ||
        message.includes('WebSocketClient')) {
        return true;
      }
    }
    if (originalErrorHandler) {
      return originalErrorHandler.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  // Also catch unhandled promise rejections related to WebSockets
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason?.message || reason?.toString() || '';
    if (message.includes('WebSocket') || message.includes('ws://localhost')) {
      event.preventDefault();
    }
  });

  // Catch all error events
  window.addEventListener('error', (event) => {
    const message = event.message || event.error?.message || '';
    if (message && (
      message.includes('WebSocket') ||
      message.includes('ws://localhost') ||
      message.includes('connection was interrupted') ||
      message.includes('WebSocketClient'))) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }, true);
}

// Performance instrumentation for startup
// const appStart = performance.now();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Hot Module Replacement (HMR) - only in development
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./App', () => {
    try {
      const NextApp = require('./App').default;
      root.render(
        <React.StrictMode>
          <NextApp />
        </React.StrictMode>
      );
    } catch (error) {
      // Ignore HMR errors for disposed modules
      console.warn('HMR update skipped:', error.message);
    }
  });
}

// Measure first render frame
requestAnimationFrame(() => {
  // Performance measurement - can be used for monitoring if needed
  // const firstFrame = performance.now() - appStart;
});

// Web vitals can be logged to analytics service in production if needed
// reportWebVitals(console.log);
